import { render, staticRenderFns } from "./odiv-rkd000-rkd.vue?vue&type=template&id=8fc8ecd8&scoped=true&"
import script from "./odiv-rkd000-rkd.vue?vue&type=script&lang=js&"
export * from "./odiv-rkd000-rkd.vue?vue&type=script&lang=js&"
import style0 from "./odiv-rkd000-rkd.vue?vue&type=style&index=0&id=8fc8ecd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc8ecd8",
  null
  
)

export default component.exports